import React, { useRef } from 'react';
import { View } from 'react-native';
/* [TODO]: HORIZONTAL/DIAGONAL DETECTIONS AND SWIPE DIRECTIONS (IF REQUIRED) */
const SwipeDetector = (props) => {
    const { children, onSwipeVertical, minTouchpoints, ...rest } = props;
    const startPosition = useRef({ startX: 0, startY: 0 });
    const swipeEnded = useRef(true);
    const callBackCalled = useRef(false);
    const onMove = ({ nativeEvent }) => {
        // WE WANT TO TRIGGER THE ONSWIPE, EVEN THOUGHT THE USER HASN'T RELEASE
        // BUT WE WANT TO INVOKE IT ONCE
        if (!swipeEnded.current && callBackCalled.current) {
            return;
        }
        if (nativeEvent.touches.length < minTouchpoints) {
            return;
        }
        const yPosition = nativeEvent.pageY;
        const verticalDiff = Math.abs(yPosition - startPosition.current.startY);
        // WE USE AN OFFSET OF 50 TO DISMISS SHORT SWIPES
        if (verticalDiff < 50) {
            return;
        }
        callBackCalled.current = true;
        onSwipeVertical?.();
    };
    const onRelease = () => {
        callBackCalled.current = false;
        swipeEnded.current = true;
    };
    const onStart = ({ nativeEvent }) => {
        if (nativeEvent.touches.length < minTouchpoints) {
            return;
        }
        startPosition.current = {
            startX: nativeEvent.pageX,
            startY: nativeEvent.pageY,
        };
        swipeEnded.current = false;
    };
    return (<View onStartShouldSetResponder={() => true} onResponderMove={onMove} onResponderStart={onStart} onResponderRelease={onRelease} {...rest}>
      {children}
    </View>);
};
SwipeDetector.displayName = 'SwipeDetector';
export default SwipeDetector;
//# sourceMappingURL=SwipeDetector.js.map